import { z } from 'zod'

// Valida las variables de entorno al iniciar la app.
// Si alguna variable falta o es inválida, la app falla inmediatamente con un error claro.
//
// Fuentes de cada variable según ambiente:
//   develop    → VITE_API_URL + VITE_ENVIRONMENT de .env.develop   | VITE_ABAKOO_API_KEY de .env.local
//   staging    → VITE_API_URL + VITE_ENVIRONMENT de .env.staging   | VITE_ABAKOO_API_KEY de Cloudflare Pages
//   production → VITE_API_URL + VITE_ENVIRONMENT de .env.production | VITE_ABAKOO_API_KEY de Cloudflare Pages
const envSchema = z.object({
  // En develop (local): vacío — las peticiones usan rutas relativas (/api/...) que el
  // proxy de Vite reenvía al backend. Necesario para que las cookies SameSite=Strict viajen.
  // En staging/production: URL completa — frontend y API comparten eTLD+1 (abakoo.cloud).
  VITE_API_URL: z.string(),
  VITE_ABAKOO_API_KEY: z.string().startsWith('abk'),
  VITE_ENVIRONMENT: z.enum(['develop', 'staging', 'production']),
  // Stripe publishable key — siempre empieza con `pk_test_` (develop/staging) o `pk_live_` (prod).
  // Es pública por diseño (viaja al browser), inyectada en CI desde GitHub Environments.
  VITE_STRIPE__PUBLICKEY: z.string().startsWith('pk_'),
})

export const env = envSchema.parse(import.meta.env)
